import { ThemeBase } from "../ThemeBase";
import polyfazerLogoTemplate from "./template/polyfazer-logo-template";
import styleSheet from "./styles/polyfazer-theme.css?inline";

/**
 * Polyfazer (2026 rebrand)
 * ---
 * The brand of the product website (web-polyfazer-v3). Replaces [PolyfazerLegacyTheme].
 */
export class PolyfazerTheme extends ThemeBase {
	static themeID = "polyfazer";

	/**
	 * @override
	 */
	get primaryColor() {
		return "#00bce8";
	}

	/**
	 * @override
	 */
	get backgroundColor() {
		return "#f3f6fc";
	}

	/**
	 * @override
	 */
	get styleSheet() {
		return styleSheet;
	}

	/**
	 * @override
	 * Brand typography of the product website: Inter for text, Jost for headings.
	 * Served from the Google Fonts host index.html already preconnects to for Roboto.
	 */
	get fontStyleSheets() {
		return ["https://fonts.googleapis.com/css2?family=Inter:wght@300..700&family=Jost:wght@400..600&display=swap"];
	}

	/**
	 * @override
	 */
	get logoForMenu() {
		return this.getLogo(`style="width: 100%; height: 40px"`);
	}

	/**
	 * @override
	 */
	get logoForLoader() {
		return this.getLogo();
	}

	/**
	 * @override
	 */
	get chargingAnimationUrl() {
		return "/themes/polyfazer/assets/images/active.svg";
	}

	/**
	 * @override
	 */
	getLogo(attributes = '') {
		return polyfazerLogoTemplate(attributes);
	}
}

new PolyfazerTheme();
